import { render } from "./developer.md?vue&type=template&id=c992a924"
import script from "./developer.md?vue&type=script&lang=js"
export * from "./developer.md?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__